import { styled } from "../../styled-components";

const Layout = styled.div`
  background-color: ${(p) => p.theme.colors.background.base};
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export { Layout };
